import React, { useState, useEffect } from 'react';
import { getAllStudents } from '../services/userService';
import { getContentCounts } from '../services/contentService';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalUsers: 0,
    activeUsers: 0,
    sightWords: 0,
    scrambleWords: 0,
    categoryWords: 0,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const [usersResult, contentCounts] = await Promise.all([
        getAllStudents(),
        getContentCounts(),
      ]);

      const users = usersResult.data || [];
      setStats({
        totalUsers: users.length,
        activeUsers: users.filter((u) => u.is_active).length,
        sightWords: contentCounts.sightWords,
        scrambleWords: contentCounts.scrambleWords,
        categoryWords: contentCounts.categoryWords,
      });
      setIsLoading(false);
    };

    load();
  }, []);

  const statCards = [
    { key: 'totalUsers',    label: 'Total Users',     icon: 'fas fa-users',        cls: 'users' },
    { key: 'activeUsers',   label: 'Active Users',    icon: 'fas fa-user-check',   cls: 'active-users' },
    { key: 'sightWords',    label: 'Sight Words',     icon: 'fas fa-book',         cls: 'sight-words' },
    { key: 'scrambleWords', label: 'Scramble Words',  icon: 'fas fa-puzzle-piece', cls: 'scramble' },
    { key: 'categoryWords', label: 'Category Words',  icon: 'fas fa-tags',         cls: 'category' },
  ];

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <h1>Admin Dashboard</h1>
        <p>Welcome to the administration panel</p>
      </div>

      {isLoading ? (
        <p style={{ textAlign: 'center', padding: '2rem' }}>Loading stats...</p>
      ) : (
        <div className="stats-grid">
          {statCards.map(({ key, label, icon, cls }) => (
            <div className="stat-card" key={key}>
              <div className={`stat-icon ${cls}`}>
                <i className={icon}></i>
              </div>
              <div className="stat-content">
                <h3>{label}</h3>
                <p className="stat-value">{stats[key]}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="recent-activity">
        <h2>Recent Activity</h2>
        <div className="activity-list">
          <div className="activity-item">
            <i className="fas fa-user-plus activity-icon"></i>
            <div className="activity-content">
              <p>Students and content are managed in the sections above.</p>
              <span className="activity-time">Use the sidebar to navigate</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
